module.exports = __webpack_public_path__ + "assets/img/picture3.28b64121.svg";